<script>
import { mapGetters } from 'vuex';


export default {
    name: "educacionFormalPostulacion",
    data() {
        return {
            baseFormacion: {
                nivelAcademicoId: null,
                institucionEducativa: null,
                tituloObtenido: null,
                fechaGraduacion: null,
                paisId: null,
            },
            departamentos: [],
            municipios: []
        }
    },
    mounted() {
        if (!this.$store.getters.resumenFormacion.length) {
            this.agregarRegistro()
        }
    },
    computed: {
        ...mapGetters([
            'getNivelesAcademicos',
            'getPaises',
            'getDepartamentos',
            'getMunicipios',
            'resumenFormacion'
        ]),
    },
    methods: {
        assertData(idx) {
            console.log(this.$store.getters.resumenFormacion[idx]);
        },
        agregarRegistro() {
            this.$store.commit('appendElement', { key: 'resumenFormacion', newElement: this.baseExperiencia })
        },
        eliminarRegistro(idx) {
            this.departamentos.splice(idx, 1)
            this.municipios.splice(idx, 1)
            this.$store.commit('deleteElementAt', { key: 'resumenFormacion', idx })
        },
        saveAndContinue() {
            const inputs = document.querySelectorAll('input, select')
            try {
                inputs.forEach(input => {
                    if (!input.checkValidity()) {
                        input.reportValidity()
                        throw new Error('Formulario incompleto')
                    }
                })

                let data = [
                    ...this.resumenFormacion.map( formacion => {
                        formacion.PostulacionId = this.$store.getters.postulacionId
                        return formacion
                    })
                ]

                this.$store.getters.fetchPost({ path: 'Postulacion/EducacionFormal', data })
                .then( response => {
                    if( response.ok )
                    {
                        return response.json()
                    }
                    throw new Error("No se ha podido guardar educación formal")
                })
                .then( result => {
                    console.log(result);
                    this.$emit('nextStep')
                })
                .catch( error => console.log(error))
                
                
            } catch (error) {
                console.log(error);
                return
            }
        },
        setDepartamentosInElement( idx, paisId = null){
            this.$store.getters.fetchGet({ path: 'DepartamentoPais/ListByPais/' + paisId })
            .then(response => {
                    if(response.ok){
                        return response.json()
                    }
                    throw new Error(response.status)
                })
                .then( data => {
                    if( idx > this.departamentos.length - 1) {
                        this.departamentos.push(data)
                    } else {
                        this.departamentos[idx] = data
                    }
                    this.departamentos = [...this.departamentos]
                })
                .catch(error => console.error(error))
        },
        setMunicipiosInElement( idx, departamentoId = null){
            this.$store.getters.fetchGet({ path: 'Municipio/ListByDepartamento/' + departamentoId })
            .then(response => {
                    if(response.ok){
                        return response.json()
                    }
                    throw new Error(response.status)
                })
                .then( data => {
                    if( idx > this.municipios.length - 1) {
                        this.municipios.push(data)
                    } else {
                        this.municipios[idx] = data
                    }
                    this.municipios = [...this.municipios]
                })
                .catch(error => console.error(error))
        }
    }
}
</script>

<template>
    <div>
        <b-form @submit.prevent="assertData(idx)" v-for="(formacion, idx) in resumenFormacion" :key="'formacion ' + idx">
            <b-row class="pb-1 px-3">
                <div class="d-flex align-items-center justify-content-between" style="width: 100%">
                    <p class="text-center my-0">
                        <b>
                            Ref. Educación forma {{ idx + 1 }}
                        </b>
                    </p>
                    <div class="pointer btn btn-outline-danger m-1" @click="eliminarRegistro(idx)">
                        <i class="fas fa-solid fa-trash px-1"></i>Eliminar
                    </div>
                </div>
            </b-row>
            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionNivel" class="form-label">Nivel académico</label>
                    <b-form-select required v-model="formacion.nivelAcademicoId" text-field="description" value-field="id"
                        :options="getNivelesAcademicos">
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm>
                    <label for="educacionInstitucion" class="form-label">Institución educativa</label>
                    <b-form-input v-model="formacion.institucionEducativa" type="text" id="educacionInstitucion" required/>
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionTitulo" class="form-label">Título obtenido</label>
                    <b-form-input v-model="formacion.tituloObtenido" type="text" id="educacionTitulo" required/>
                </b-col>
                <b-col sm>
                    <label for="educacionFecha" class="form-label">Fecha finalización de los
                        estudios</label>
                    <b-form-input v-model="formacion.fechaGraduacion" type="date" id="educacionFecha" required/>
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionPais" class="form-label">País</label>
                    <b-form-select required v-model="formacion.paisId" text-field="descripcion" value-field="id"
                        :options="getPaises" 
                        @change.native="setDepartamentosInElement( idx, formacion.paisId)">
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm>
                    <label for="educacionDepartamento" class="form-label">Departamento</label>
                    <b-form-select required v-model="formacion.departamentoId" text-field="descripcion" value-field="id"
                        :options="departamentos[idx]"
                        @change.native="setMunicipiosInElement( idx, formacion.departamentoId)">
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionMunicipio" class="form-label">Municipio</label>
                    <b-form-select required v-model="formacion.municipioId" text-field="descripcion" value-field="id"
                        :options="municipios[idx]">
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm></b-col>
            </b-row>
            <!-- <b-row class="py-2 px-3">
                <div class="d-flex flex-row" style="width: 100%">
                    <button class="btn px-4 py-2 btn-primary">
                        <span> Guardar </span>
                    </button>
                </div>
            </b-row> -->
        </b-form>
        <div class="d-flex flex-row-reverse py-2" style="width: 100%; gap: 5px">
            <button class="btn px-4 py-2 btn-primary" @click="saveAndContinue">
                <span> Guardar y continuar </span>
            </button>
            <button class="btn px-4 py-2 btn-outline-success" @click="agregarRegistro">
                <span> Nuevo registro </span>
            </button>
        </div>
    </div>
</template>
